import { create } from 'zustand';

const useNavigationHelperStore = create((set) => ({
  // Store state
  from: null,
  state: null,
  selectedReport: null,

  // Actions
  setNavigation: (value, state = null) => set({ from: value, state: state }),
  resetNavigation: () => set({ from: null, state: null, selectedReport: null }),
  setSelectedReport: (value) => set({ selectedReport: value }),
  resetSelectedReport: () => set({ selectedReport: null }),      

}));

export default useNavigationHelperStore; 